// extracted by mini-css-extract-plugin
export default {"tabsNews":"index_tabsNews_PZgV0","cut":"index_cut_PO9MC","tabs":"index_tabs_ERfe2","itis":"index_itis_m-Gl1"};